import {
  withDateEditorFilter,
  withSelectorSwitch,
} from 'shared/components/data-display/editors';
import { FILTER_DISPLAY_TYPE } from '../../../shared/constants';

const dateFilters = [
  {
    label: 'Start Date',
    param: 'start_date',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withDateEditorFilter(),
  },
  {
    label: 'End Date',
    param: 'end_date',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withDateEditorFilter(),
  },
  {
    label: 'All Time?',
    param: 'all_time',
    type: FILTER_DISPLAY_TYPE.control,
    FilterComponent: withSelectorSwitch(),
  },
];

export default dateFilters;
